// Shown on every page while a superadmin is signed in as somebody else (admin login-as; the server side
// is modules/loginAs.js). The session covers the whole site, so this sits in the shared AppBase, not in
// one app. /api/auth/check says who is looking; "Back to my account" restores their own session and
// returns them to the admin's user list.
import React, { useState } from 'react';
import styled from 'styled-components/macro';

import { httpAPI } from '@mirinae/apis/http';
import { apiPaths } from '@mirinae/defines/paths';

const LoginAsBanner = ({ user, loginAs }) => {
    const [busy, setBusy] = useState(false);
    const [failed, setFailed] = useState(false);

    const goBack = () => {
        setBusy(true);
        setFailed(false);
        httpAPI('', apiPaths.loginAsReturn)
            .then(() => window.location.assign('/admin/users'))
            // refused when the original account may no longer return; the browser is signed out then
            .catch(() => { setBusy(false); setFailed(true); });
    };

    return (
        <Bar role="status">
            <span>Viewing as <strong>{user.name || user.email || 'this account'}</strong> (signed in by {loginAs.by}). Changes here are made to this account.</span>
            <BackButton type="button" onClick={goBack} disabled={busy}>Back to my account</BackButton>
            {failed && <span>Could not go back. Sign in again.</span>}
        </Bar>
    );
};

export default LoginAsBanner;

const Bar = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100000;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 10px 16px;
    background: #b42318;
    color: #fff;
    font-size: 14px;
`;

const BackButton = styled.button`
    padding: 6px 14px;
    border: 1px solid #fff;
    border-radius: 4px;
    background: transparent;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    &:disabled { opacity: .6; cursor: default; }
`;
